<template>
  <v-tooltip
    top
    v-if="!screenData.hide"
    content-class="vies-tooltip-content"
  >
    <template v-slot:activator="{ on }">
      <div class="vies" v-on="on">
        <v-icon
          class="vies__icon"
          size="14"
          :color="statusColor"
        >
          {{ statusIcon }}
        </v-icon>

        <span class="vies__text" :class="statusClass">
          {{ statusText }}
        </span>
      </div>
    </template>

    <div class="vies-tooltip">
      <div class="vies-tooltip__disclaimer">
        La validación del VIES tiene carácter informativo
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import { ViesValidatorInfra } from "@/modules/invoices/infra/ViesValidatorInfra";
import { ViesValidatorApplication } from "@/modules/invoices/app/ViesValidatorApplication";
import { ViesValidatorComponent, createScreenData } from "@/components/ViesValidatorComponent";
import { sync_command_dispatcher } from "@/api/client";

export default {
  name: "ViesValidator",

  props: {
    third: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      screenData: createScreenData(),
      component: null
    };
  },

  computed: {
    statusIcon() {
      if (this.screenData.isLoading) return "mdi-loading";
      if (this.screenData.isError) return "mdi-alert-circle-outline";
      return this.screenData.valid
        ? "mdi-check-circle-outline"
        : "mdi-alert-circle-outline";
    },

    statusText() {
      if (this.screenData.isLoading) return "Validando VIES...";
      if (this.screenData.isError) return this.screenData.message;
      return this.screenData.valid ? "VIES válido" : "VIES inválido";
    },

    statusColor() {
      if (this.screenData.isLoading) return "#9ca3af";
      if (this.screenData.isError) return "#f59e0b";
      return this.screenData.valid ? "#16a34a" : "#f59e0b";
    },

    statusClass() {
      if (this.screenData.isLoading) return "vies--loading";
      if (this.screenData.isError) return "vies--warning";
      return this.screenData.valid ? "vies--success" : "vies--warning";
    }
  },

  methods: {
    validateVies() {
      if (!this.third || !this.third.cif) return;
      this.component.validateVies(this.third.cif, this.third.country);
    }
  },

  mounted() {
    const infra = new ViesValidatorInfra(sync_command_dispatcher);
    const application = new ViesValidatorApplication(infra);
    this.component = new ViesValidatorComponent(application, this.screenData);
    this.validateVies();
  },

  watch: {
    "third.cif"() {
      this.validateVies();
    },
    "third.country"() {
      this.validateVies();
    }
  }
};
</script>

<style scoped>
.vies {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
}

.vies__icon {
  display: flex;
  align-items: center;
}

.vies__text {
  font-weight: 500;
}

.vies--success { color: #16a34a; }
.vies--warning { color: #f59e0b; }
.vies--loading { color: #9ca3af; font-style: italic; font-weight: 400; }

.vies__icon .mdi-loading {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>

<style>
.vies-tooltip-content {
  background: #2f2f36 !important;
  border-radius: 8px !important;
  padding: 12px 14px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35) !important;
  font-size: 13px !important;
  max-width: 300px;
}

.vies-tooltip {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.vies-tooltip__disclaimer {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.vies-tooltip__row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.vies-tooltip__label {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.vies-tooltip__value {
  color: #ffffff;
  font-weight: 600;
}
</style>